var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Cookies from 'js-cookie';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class RuntimePermissions {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    get solidApp() {
        return this.runtime.solidBrowserRuntime.app;
    }
    get hasEditPermissions() {
        if (this.runtime.isServerRuntime)
            return true;
        if (!this.solidApp.user)
            return false;
        if (!this.runtime.availablePackages.Edit)
            return false;
        return this.solidApp.user.userPermissions.hasEditPermissionsForCurrentLocation;
    }
    get hasAdminPermissions() {
        if (this.runtime.isServerRuntime)
            return true;
        if (!this.solidApp.user)
            return false;
        if (!this.runtime.availablePackages.Edit)
            return false;
        return this.solidApp.user.userPermissions.hasAdminPermissionsForCurrentLocation;
    }
    get hasEditFunctionality() {
        if (this.runtime.isServerRuntime) {
            return false;
        }
        if (this.runtime.isBot)
            return true;
        return !!Cookies.get('edit');
    }
    ensureEditFunctionality() {
        if (!Cookies.get('edit')) {
            Cookies.set('edit', '1', { expires: 365, secure: true });
            if (this.runtime.isBrowserRuntime) {
                window.location.reload();
            }
        }
    }
    get isAutoTextSizingEnabled() {
        if (!this.runtime.browserRuntime)
            return false;
        if (this.hasEditFunctionality) {
            return true;
        }
        const { app } = this.runtime.solidBrowserRuntime;
        // if (!app.pathURI.includes('klasse1/deutsch/wörter')) return true;
        if (app.question &&
            app.question.questionLayout.layoutBundle &&
            app.question.questionLayout.layoutBundle.local.valueOf.textGrowEnable === 'endUser') {
            return true;
        }
        return false;
    }
}
__decorate([
    memoize
], RuntimePermissions.prototype, "hasEditFunctionality", null);
